﻿import axios from 'axios';
import buttonLoader from '../../utilities/buttonLoader';

const initialProps = {
  container: '.js-flow-container',
  flowContainer: '.checkout-step',
  nextStep: '.checkout-nextstep',
  goBack: '.checkout-goback',
  noLogin: '.checkout-nologin',
  login: '.checkout-login',
  loginForm: '.cart__login-form',
  submitForm: '.checkout-finish'
};

class CheckoutFlow {
  constructor(props) {
    this.props = props ? props : initialProps;
    const container = document.querySelector(this.props.container) ? document.querySelector(this.props.container) : null;
    if (container) {
      this.bind(container);
    }
  }
  bind(container) {
    const flowContainers = container.querySelectorAll(this.props.flowContainer) ? document.querySelectorAll(this.props.flowContainer) : null;
    flowContainers.forEach((flowStep, index) => {
      const flowNext = flowStep.querySelectorAll(this.props.nextStep) ? flowStep.querySelectorAll(this.props.nextStep) : null;
      const flowBack = flowStep.querySelector(this.props.goBack) ? flowStep.querySelector(this.props.goBack) : null;
      const withoutLogin = flowStep.querySelector(this.props.noLogin) ? flowStep.querySelector(this.props.noLogin) : null;
      const login = flowStep.querySelector(this.props.loginForm) ? flowStep.querySelector(this.props.loginForm) : null;
      const form = flowStep.querySelector('form') ? flowStep.querySelector('form') : null;
      if (login) {
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.login();
        })
      }
      if (flowNext) {
        flowNext.forEach(next => {
          if (form) {
            form.addEventListener('submit', (e) => {
              if (!form.classList.contains('cart__login-form')) {
                const currentFlow = flowStep;
                const nextFlow = flowContainers[index + 1];
                this.next(currentFlow, nextFlow);
              }
            })
          }
          else {
            next.addEventListener('click', e => {
              const currentFlow = flowStep;
              const nextFlow = flowContainers[index + 1];
              this.next(currentFlow, nextFlow);
            })
          }
        })
      }
      if (withoutLogin) {
        withoutLogin.addEventListener('click', (e) => {
            const currentFlow = flowStep;
            const nextFlow = flowContainers[index + 1];
            this.next(currentFlow, nextFlow);
        })
      }
      if (flowBack) {
        flowBack.addEventListener('click', (e) => {
          e.preventDefault();;
          const currentFlow = flowStep;
          const lastFlow = flowContainers[index - 1];
          this.back(currentFlow, lastFlow);
        })
      }
    });
  }
  login() {
    const form = document.querySelector(this.props.loginForm);
    const loginButton = document.querySelector('.js-checkout-login');
    const me = this;
    const url = form.getAttribute("action");
    const data = new FormData(form);
    buttonLoader.start(loginButton);

    if (document.querySelector('.checkout__form .error') != null) {
      document.querySelector('.checkout__form .error').remove();
    }

    axios.post(url, data)
      .then(res => res.data)
      .then((res) => {
        if(res.success) {
          window.location = "/greida";
          buttonLoader.success(loginButton);
        }
        else {
          me.renderMessage(form, res.message, 'error');
          buttonLoader.reset(loginButton);
        }
        return res;
        
      })
      .catch((error) => {
        me.renderMessage(form, 'Server error', 'error');
        buttonLoader.reset(loginButton);
        return error;
      })
      /*
    var xhr = new XMLHttpRequest();
    xhr.open(form.getAttribute("method"), form.getAttribute("action"));
    buttonLoader.start(loginButton)
    xhr.onload = function () {

      var resp = JSON.parse(xhr.response);

      if (xhr.status >= 200 && xhr.status < 300) {

          if (resp.success) {
            buttonLoader.success(loginButton)
            window.location = "/greida";


          } else {
            buttonLoader.reset(loginButton)
              me.renderMessage(form, resp.message, 'error');
          }

      } else {
        buttonLoader.reset(loginButton)
          me.renderMessage(form, 'Server error', 'error');
      }
    }
    xhr.send(data);
    */
  }
  next(currentFlow, nextFlow) {
    currentFlow.classList.add('is-hidden')
    nextFlow.classList.remove('is-hidden')
  }
  back(currentFlow, lastFlow) {
    currentFlow.classList.add('is-hidden')
    lastFlow.classList.remove('is-hidden')
  }
  renderMessage(el, message, type) {
    el.insertAdjacentHTML('afterend', '<div class="alert ' + type + '">' + message + '</div>');
  }
}

export default CheckoutFlow
